import React, { useState } from 'react';
import authService from '../../services/auth.service';
import storeService from '../../services/store.service';
import superAdminService from '../../services/superAdmin.service';
import {
  clearSupportAccess,
  getSupportAccess,
  simulatedUserLabel,
} from '../../utils/superAdminSupportAccess';
import './SuperAdminSupportBanner.scss';

const SuperAdminSupportBanner: React.FC = () => {
  const access = getSupportAccess();
  const [leaving, setLeaving] = useState(false);
  if (!access) return null;

  const viewLabel = simulatedUserLabel(access.simulatedUser);

  const handleReturn = async () => {
    if (leaving) return;
    setLeaving(true);
    const returnTo = access.returnTo || '/super-admin/stores';
    try {
      await superAdminService.endPlatformStoreAccessSession(access.storeId);
    } catch {
      /* best-effort cleanup */
    }
    clearSupportAccess();
    authService.clearAuthData();
    storeService.clearCurrentStore();
    window.location.assign(returnTo);
  };

  return (
    <div className="sa-support-banner" role="status">
      <span>
        Support · {access.storeName}
        {viewLabel ? ` · ${viewLabel}` : ''}
      </span>
      <button type="button" className="sa-support-banner__back" onClick={handleReturn} disabled={leaving}>
        Retour console
      </button>
    </div>
  );
};

export default SuperAdminSupportBanner;
